import React from "react";

export default function Samples () {
    return (
        <>
        <div id="sampleblock">
             <div id="arrowleft"><img src="../images/arrowleft.png"/></div>
             <div id="arrowright"><img src="../images/arrowright.png"/></div>
            <div id="samples">Примеры выигранных дел по банкротству со сканами судебных решений</div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm samplecol margr" id="case1">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm">
                                    <img className="dealpic" src="../images/delo.png"/>
                                </div>
                                 <div className="col-sm">
                                    <div className="dealtitle">Дело № А40-188442/2020</div>
                                     <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-sm subdealleft">
                                            Сумма долга:
                                            </div>
                                            <div className="col-sm-4 subdealright">
                                            2 282 093 ₽
                                            </div>
                                        </div>
                                        <div className="row">
                                             <div className="col-sm subdealleft">
                                            Списано:
                                            </div>
                                            <div className="col-sm-4 subdealright">
                                            2 282 093 ₽
                                            </div>
                                        </div>
                                         <div className="row">
                                             <div className="col-sm subdealleft">
                                            Поступило в работу:
                                            </div>
                                            <div className="col-sm-4 subdealright">
                                            29.09.2020
                                            </div>
                                        </div>
                                         <div className="row">
                                             <div className="col-sm subdealleft">
                                            Подача заявления:
                                            </div>
                                            <div className="col-sm-4 subdealright">
                                            29.09.2020
                                            </div>
                                        </div>
                                         <div className="row">
                                             <div className="col-sm subdealleft">
                                            Признан банкротом:
                                            </div>
                                            <div className="col-sm-4 subdealright">
                                            29.09.2020
                                            </div>
                                        </div>
                                        <div className="row">
                                             <div className="col-sm subdealleft">
                                            Завершено:
                                            </div>
                                            <div className="col-sm subdealright">
                                            29.09.2020
                                            </div>
                                        </div>
                                        <div className="row">
                                             <div className="col-sm subdealitogleft">
                                            Заняло времени:
                                            </div>
                                            <div className="col-sm subdealitogright">
                                            0 мес. 0 дн.
                                            </div>
                                        </div>
                                        <div className="row">
                                             <div className="col-sm subdealdetails">
                                            <a href="#">Подробнее</a>
                                            </div>
                                            <div className="col-sm">
                                           
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm samplecol margr" id="case2">
                     <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm">
                                    <img className="dealpic" src="../images/delo.png"/>
                                </div>
                                 <div className="col-sm">
                                    <div className="dealtitle">Дело № А40-188442/2020</div>
                                     <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-sm subdealleft">
                                            Сумма долга:
                                            </div>
                                            <div className="col-sm-4 subdealright">
                                            2 282 093 ₽
                                            </div>
                                        </div>
                                        <div className="row">
                                             <div className="col-sm subdealleft">
                                            Списано:
                                            </div>
                                            <div className="col-sm-4 subdealright">
                                            2 282 093 ₽
                                            </div>
                                        </div>
                                         <div className="row">
                                             <div className="col-sm subdealleft">
                                            Поступило в работу:
                                            </div>
                                            <div className="col-sm-4 subdealright">
                                            29.09.2020
                                            </div>
                                        </div>
                                         <div className="row">
                                             <div className="col-sm subdealleft">
                                            Подача заявления:
                                            </div>
                                            <div className="col-sm-4 subdealright">
                                            29.09.2020
                                            </div>
                                        </div>
                                         <div className="row">
                                             <div className="col-sm subdealleft">
                                            Признан банкротом:
                                            </div>
                                            <div className="col-sm-4 subdealright">
                                            29.09.2020
                                            </div>
                                        </div>
                                        <div className="row">
                                             <div className="col-sm subdealleft">
                                            Завершено:
                                            </div>
                                            <div className="col-sm subdealright">
                                            29.09.2020
                                            </div>
                                        </div>
                                        <div className="row">
                                             <div className="col-sm subdealitogleft">
                                            Заняло времени:
                                            </div>
                                            <div className="col-sm subdealitogright">
                                            0 мес. 0 дн.
                                            </div>
                                        </div>
                                        <div className="row">
                                             <div className="col-sm subdealdetails">
                                            <a href="#">Подробнее</a>
                                            </div>
                                            <div className="col-sm">
                                           
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center">
                <button id="alldealbtn">Все дела</button>
        </div>   
        </>
    )
}